<div cdkDropList
     *ngIf="isDraggable; else nonDraggableList"
     (cdkDropListDropped)="onDrop($event)"
     class="table-wrapper">
  <table class="order-table">
    <thead>
      <tr>
        <th *ngIf="isSelectable">
          <mat-checkbox [(ngModel)]="selectAll"
                        (change)="toggleSelectAll($event)"
                        [indeterminate]="isIndeterminate()">
          </mat-checkbox>
        </th> <!-- Select All checkbox -->
        <th></th> <!-- Drag handle column -->
        <th>Name</th>
        <th>Created By</th>
        <th>Assigned for Delivery</th>
        <th>State</th>
        <th>Created At</th>
        <th>Note</th>
        <th># of Orders</th>
        <th *ngIf="showMarkReady">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let load of loads; let i = index"
          cdkDrag
          class="clickable-row"
          (dblclick)="onLoadClick(load)">
        <td *ngIf="isSelectable">
          <mat-checkbox [(ngModel)]="load.selected" (change)="onSelectionChange()"></mat-checkbox>
        </td> <!-- Row checkbox -->
        <td><mat-icon cdkDragHandle class="drag-icon">drag_indicator</mat-icon></td>
        <td>{{ load.name }}</td>
        <td>{{ load.salesManName }}</td>
        <td>
          <div class="delivery-info">
            <mat-icon>
              {{ load.deliveryBoyId ? 'check_circle' : 'hourglass_empty' }}
            </mat-icon>
            <span *ngIf="load.deliveryBoyName">
              {{ load.deliveryBoyName }}
            </span>
          </div>
        </td>
        <td>{{ load.state }}</td>
        <td>{{ load.createdAt | date: 'short' }}</td>
        <td>
          <span [title]="load.note || ''">{{ load.note || '' }}</span>
        </td>
        <td>{{ load.numberOfOrders }}</td>
        <td>
          <ng-container *ngIf="showMarkReady">
            <!-- Show action button when still in transit -->
            <button
              *ngIf="load.state === 'in_transit'"
              mat-flat-button
              color="accent"
              class="settle-btn"
              (click)="$event.stopPropagation(); markReadySettlement.emit(load)"
              aria-label="Mark this load ready for settlement"
              matTooltip="Mark this load as Ready for Settlement"
            >
              <mat-icon class="leading">task_alt</mat-icon>
              <span>Mark&nbsp;Ready</span>
            </button>
        
            <!-- Show badge when already marked ready -->
            <span
              *ngIf="load.state === 'ready_settlement'"
              class="badge badge-ready"
              matTooltip="Already marked Ready for Settlement"
              aria-label="Ready for Settlement"
            >
              <mat-icon class="leading">verified</mat-icon>
              Ready
            </span>
          </ng-container>
        </td>        
      </tr>
    </tbody>
  </table>
</div>

<ng-template #nonDraggableList>
  <div class="table-wrapper">
    <table class="order-table">
      <thead>
        <tr>
          <th *ngIf="isSelectable">
            <mat-checkbox [(ngModel)]="selectAll"
                          (change)="toggleSelectAll($event)"
                          [indeterminate]="isIndeterminate()">
            </mat-checkbox>
          </th> <!-- Select All checkbox -->
          <th>Name</th>
          <th>Created By</th>
          <th>Assigned for Delivery</th>
          <th>State</th>
          <th>Created At</th>
          <th>Note</th>
          <th># of Orders</th>
          <th *ngIf="showMarkReady">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let load of loads"
            class="clickable-row"
            (dblclick)="onLoadClick(load)">
          <td *ngIf="isSelectable">
            <mat-checkbox [(ngModel)]="load.selected" (change)="onSelectionChange()"></mat-checkbox>
          </td> <!-- Row checkbox -->
          <td>{{ load.name }}</td>
          <td>{{ load.salesManName }}</td>
          <td>
            <div class="delivery-info">
              <mat-icon>
                {{ load.deliveryBoyId ? 'check_circle' : 'hourglass_empty' }}
              </mat-icon>
              <span *ngIf="load.deliveryBoyName">
                {{ load.deliveryBoyName }}
              </span>
            </div>
          </td>
          <td>{{ load.state }}</td>
          <td>{{ load.createdAt | date: 'short' }}</td>
          <td>
            <span [title]="load.note || ''">{{ load.note || '' }}</span>
          </td>
          <td>{{ load.numberOfOrders }}</td>
          <td>
            <ng-container *ngIf="showMarkReady">
              <button
                *ngIf="load.state === 'in_transit'"
                mat-flat-button
                color="accent"
                class="settle-btn"
                (click)="$event.stopPropagation(); markReadySettlement.emit(load)"
                aria-label="Mark this load ready for settlement"
                matTooltip="Mark this load as Ready for Settlement"
              >
                <mat-icon class="leading">task_alt</mat-icon>
                <span>Mark&nbsp;Ready</span>
              </button>
          
              <span
                *ngIf="load.state === 'ready_settlement'"
                class="badge badge-ready"
                matTooltip="Already marked Ready for Settlement"
                aria-label="Ready for Settlement"
              >
                <mat-icon class="leading">verified</mat-icon>
                Ready
              </span>
            </ng-container>
          </td>          
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
